import { YupAnyObjectSchema } from '@framework/validation';
import { ISerializedFormSectionValue } from './ISerializedFormSectionValue';
import { deserializeFormValues } from './deserializeFormValues';

/**
 * Deserializza e mappa i dati delle sezioni fornite dal BE, trasformandole in un oggetto:
 * {
 *  "<id-sezione>": {...valori},
 *  "<id-sezione>": {...valori},
 * ...
 * }
 */
export function deserializeFormSectionsValues(
  validationSchema: YupAnyObjectSchema,
  values: ISerializedFormSectionValue[] | null | undefined,
) {
  if (!values) return {};
  if (!validationSchema) return {};

  const data = values.map(v => v.valori ?? {});

  return deserializeFormValues(validationSchema, { values: data });
}
